import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toast } from 'sonner';
import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
/** Valor com botão de copiar (servidores DNS etc.). */
export function CopyBox({ value }) {
    return (_jsxs("div", { className: "flex h-9 items-center gap-1.5 rounded-md border bg-muted/40 pl-3 pr-1", children: [_jsx("span", { className: "flex-1 truncate font-mono text-xs", children: value }), _jsx(Button, { variant: "ghost", size: "icon", className: "h-7 w-7", "aria-label": `Copiar ${value}`, onClick: () => navigator.clipboard
                    .writeText(value)
                    .then(() => toast.success('Copiado!'))
                    .catch(() => toast.error('Não foi possível copiar.')), children: _jsx(Copy, { className: "!size-3.5" }) })] }));
}
